import { DEFAULT_PROJECT_ID } from '@/lib/defaultProject';

/** Rows grouped by project: the default one first, then by name. */
export function groupByProject<T>(
    rows: T[],
    projectOf: (row: T) => { id: string; name: string },
): { id: string; name: string; rows: T[] }[] {
    const groups = new Map<string, { id: string; name: string; rows: T[] }>();
    for (const row of rows) {
        const { id, name } = projectOf(row);
        const group = groups.get(id) ?? { id, name, rows: [] };
        group.rows.push(row);
        groups.set(id, group);
    }
    return [...groups.values()].sort(
        (a, b) =>
            Number(b.id === DEFAULT_PROJECT_ID) -
                Number(a.id === DEFAULT_PROJECT_ID) ||
            a.name.localeCompare(b.name),
    );
}

/**
 * The project, as a row across the table: enough to see where its rows start,
 * and quieter than them, which are what is read first.
 */
export function ProjectGroupRow({
    name,
    count,
    colSpan,
}: {
    name: string;
    count: number;
    colSpan: number;
}) {
    return (
        <tr className="border-t-2 border-[#3a434c]">
            <td
                colSpan={colSpan}
                className="px-4 pt-2 pb-0 text-[10px] leading-none font-medium uppercase tracking-wider text-[#6b7480]"
            >
                {/* A tag behind the name only; the negative margin keeps its
                    letters on the column's edge. */}
                <span className="-ml-1.5 inline-block rounded bg-[#222a31] px-1.5 py-1 text-[#8a929c]">
                    {name}
                </span>
                <span className="ml-2 text-[#4a525c]">{count}</span>
            </td>
        </tr>
    );
}
